$(function() {

    $('body').on('click', '.custom-modal .modal-close', function (e) {
        e.preventDefault();

        $(this).closest('.custom-modal').fadeOut(300);
        $('.custom-modal__overlay').fadeOut(300);

        revert_video($(this).closest('.custom-modal'));
    });

    $('.custom-modal__overlay').on('click', function (e) {
        e.preventDefault();

        $('.custom-modal').fadeOut(300);
        $(this).fadeOut(300);

        revert_video($('.custom-modal.welcome-popup'));

    });

    $('.support-contact').on('click', function (e) {
        e.preventDefault();

        //Show contact form modal
        change_welcome_tab(3, 0);
        $('.custom-modal__overlay, .welcome-popup').fadeIn(300);
        scroll_to_pos(0);

    });

});